function _typeof(o) {
  '@babel/helpers - typeof';
  return (
    (_typeof =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (o) {
            return typeof o;
          }
        : function (o) {
            return o &&
              'function' == typeof Symbol &&
              o.constructor === Symbol &&
              o !== Symbol.prototype
              ? 'symbol'
              : typeof o;
          }),
    _typeof(o)
  );
}
var _excluded = ['menu', 'trigger', 'children', 'getPopupContainer', 'disabled'];
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r &&
      (o = o.filter(function (r) {
        return Object.getOwnPropertyDescriptor(e, r).enumerable;
      })),
      t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2
      ? ownKeys(Object(t), !0).forEach(function (r) {
          _defineProperty(e, r, t[r]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
      : ownKeys(Object(t)).forEach(function (r) {
          Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true,
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, 'string');
  return _typeof(key) === 'symbol' ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}
function _slicedToArray(arr, i) {
  return (
    _arrayWithHoles(arr) ||
    _iterableToArrayLimit(arr, i) ||
    _unsupportedIterableToArray(arr, i) ||
    _nonIterableRest()
  );
}
function _nonIterableRest() {
  throw new TypeError(
    'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
  );
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === 'string') return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === 'Object' && o.constructor) n = o.constructor.name;
  if (n === 'Map' || n === 'Set') return Array.from(o);
  if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(r, l) {
  var t =
    null == r ? null : ('undefined' != typeof Symbol && r[Symbol.iterator]) || r['@@iterator'];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (((i = (t = t.call(r)).next), 0 === l)) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {}
    } catch (r) {
      (o = !0), (n = r);
    } finally {
      try {
        if (!f && null != t.return && ((u = t.return()), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React, { useMemo } from 'react';
import { Modal, Dropdown, Menu } from 'udesk-ui';
import { useLocaleReceiver } from '../locale-provider/LocaleReceiver';
var BatchedActions = function BatchedActions(props) {
  var _props$menu = props.menu,
    menuProps = _props$menu === void 0 ? [] : _props$menu,
    trigger = props.trigger,
    children = props.children,
    getPopupContainer = props.getPopupContainer,
    disabled = props.disabled,
    node = _objectWithoutProperties(props, _excluded);
  var _useLocaleReceiver = useLocaleReceiver('BatchedActions'),
    _useLocaleReceiver2 = _slicedToArray(_useLocaleReceiver, 1),
    contextLocale = _useLocaleReceiver2[0];
  var menu = useMemo(
    function () {
      return /*#__PURE__*/ React.createElement(
        Menu,
        null,
        menuProps.map(function (item) {
          var _item$onClick2;
          var disabled = typeof item.disabled === 'function' ? item.disabled(node) : item.disabled;
          var params = _objectSpread(
            _objectSpread({}, node),
            {},
            {
              key: node.itemKey,
            },
          );
          return /*#__PURE__*/ React.createElement(
            Menu.Item,
            {
              danger: !disabled && item.danger,
              disabled: disabled,
              key: item.label,
              onClick:
                item.danger || item.confirm
                  ? function () {
                      var _item$onClick;
                      Modal.confirm(
                        _objectSpread(
                          _objectSpread(
                            _objectSpread({}, contextLocale.lang.confirm),
                            item.confirm || {},
                          ),
                          {},
                          {
                            onOk:
                              (_item$onClick = item.onClick) === null || _item$onClick === void 0
                                ? void 0
                                : _item$onClick.bind(null, params),
                            getContainer: getPopupContainer,
                          },
                        ),
                      );
                    }
                  : (_item$onClick2 = item.onClick) === null || _item$onClick2 === void 0
                  ? void 0
                  : _item$onClick2.bind(null, params),
            },
            item.label,
          );
        }),
      );
    },
    [menuProps, node],
  );
  return /*#__PURE__*/ React.createElement(
    Dropdown,
    {
      disabled: disabled,
      overlay: menu,
      trigger: trigger,
      getPopupContainer: getPopupContainer,
      className: 'batched-actions-dropdown',
    },
    children,
  );
};
export default BatchedActions;
